import React from "react"
import RequireSubFeature from "components/hoc/Require_Sub_Feature"
import Section from "components/layout/Section"
import FormWrapper from "components/layout/Form_Wrapper"
import HomeCareEntryForm from "containers/features/Home_Care/forms/Litter_Home_Care_Entry_Form"

function NewEntryView(props) {
  return (
    <Section>
      <FormWrapper>
        <HomeCareEntryForm {...props} />
      </FormWrapper>
    </Section>
  )
}

export default RequireSubFeature(NewEntryView)
